import { normalizeText, normalizeDigits, normalizeDocumentByType } from "./identity-utils";
import { buildDocumentRequirementsPayload } from "../config/document-requirements";

export const serializeDocuments = (documents) => documents.map((document) => ({
  name: document.name,
  requirementKey: document.requirementKey || "",
  specialityId: document.specialityId || null,
  size: document.size,
  type: document.type,
}));

export const buildSubmitFormData = (payload, documents) => {
  const formData = new FormData();
  formData.append("payload", JSON.stringify(payload));
  documents.forEach((document) => {
    if (document.file) formData.append("documents", document.file, document.name);
  });
  return formData;
};

// Reparte los telefonos guardados (solicitud o medico) en los campos del formulario sin duplicarlos.
export const getContactPhones = (source) => {
  const cellphone = normalizeText(source?.cellphone || source?.phone);
  const phone = normalizeText(source?.phone);
  return {
    cellphone,
    phone: phone && phone !== cellphone ? phone : "",
    phone2: normalizeText(source?.phone2),
  };
};

export const buildPreregistrationPayload = (form, documents, representativeValidation) => {
  return {
    preregistrationId: Number(form.preregistrationId || 0) || null,
    recoveryEmail: normalizeText(
      form.personType === "FISICA" ? form.physicalEmail : form.businessEmail,
    ).toLowerCase(),
    firstName:
      form.personType === "FISICA"
        ? normalizeText(form.physicalFirstName)
        : normalizeText(form.repFirstName),
    middleName:
      form.personType === "FISICA"
        ? normalizeText(form.physicalMiddleName)
        : normalizeText(form.repMiddleName),
    lastName:
      form.personType === "FISICA"
        ? normalizeText(form.physicalLastName)
        : normalizeText(form.repLastName),
    lastName2:
      form.personType === "FISICA"
        ? normalizeText(form.physicalLastName2)
        : normalizeText(form.repLastName2),
    identificationCard: normalizeDocumentByType(form.documentNumber, form.documentType),
    documentType: normalizeText(form.documentType).toUpperCase(),
    email:
      form.personType === "FISICA"
        ? normalizeText(form.physicalEmail)
        : normalizeText(form.repEmail),
    // El medico guarda Telefono, Telefono 2 y Celular; el celular es el contacto obligatorio.
    phone:
      form.personType === "FISICA"
        ? normalizeDigits(form.physicalPhone || form.physicalCellphone)
        : normalizeDigits(form.repPhone || form.repCellphone),
    cellphone: normalizeDigits(
      form.personType === "FISICA" ? form.physicalCellphone : form.repCellphone,
    ),
    phone2: normalizeDigits(
      form.personType === "FISICA" ? form.physicalPhone2 : form.repPhone2,
    ),
    personType: normalizeText(form.personType),
    legalPersonalityId: form.personType === "MORAL" ? 2 : 1,
    isMedical: Boolean(form.isMedical),
    exequatur: normalizeText(form.physicalExequatur),
    specialities: (form.specialities || [])
      .map((speciality) => ({ id: Number(speciality.id || 0) }))
      .filter((speciality) => speciality.id > 0),
    officeName: normalizeText(form.commercialName || form.officeName),
    branchName: normalizeText(form.branchName),
    address:
      form.personType === "FISICA"
        ? normalizeText(form.physicalAddress)
        : normalizeText(form.businessAddress),
    provinceId:
      form.personType === "FISICA"
        ? Number(form.physicalProvince || 0) || null
        : Number(form.businessProvince || 0) || null,
    municipalityId:
      form.personType === "FISICA"
        ? Number(form.physicalMunicipality || 0) || null
        : Number(form.businessMunicipality || 0) || null,
    sectorId:
      form.personType === "FISICA"
        ? Number(form.physicalSector || 0) || null
        : Number(form.businessSector || 0) || null,
    businessName: normalizeText(form.businessName),
    commercialName: normalizeText(form.commercialName),
    businessEmail:
      form.personType === "MORAL" ? normalizeText(form.businessEmail) : "",
    businessPhone:
      form.personType === "MORAL"
        ? normalizeDigits(form.businessCellphone || form.businessPhone)
        : "",
    representativeDocumentType:
      form.personType === "MORAL"
        ? normalizeText(form.repDocumentType).toUpperCase()
        : "",
    representativeDocumentNumber:
      form.personType === "MORAL"
        ? normalizeDocumentByType(form.repDocumentNumber, form.repDocumentType)
        : "",
    existingUserId:
      form.personType === "MORAL"
        ? Number(representativeValidation.existingUser?.id || 0) || null
        : null,
    documents: serializeDocuments(documents),
    documentRequirements: buildDocumentRequirementsPayload(form, documents),
  };
};
